import { selector } from 'recoil';
import {
  apiGetUserProfile,
  apiGetExercise,
  apiGetNutrition,
  apiGetRecommenderExercises,
  apiGetRecommenderRecipes,
  apiGetDna24Profile,
  apiGetGenotypeWithErrorCatch,
  apiGetRecommenderMealplan,
} from 'dataLayer/api/apiClient';
import {
  recommenderExercisesRequestIdAtom,
  recommenderRecipesRequestIdAtom,
  recommenderMealplanRequestIdAtom,
} from 'dataLayer/recoil/apiData/requestIdAtoms';

/**
 * Default atom selectors can't be contained in selectors.js file because of the circular referencing.
 */
export const userProfileSelectorGet = selector({
  key: 'apiData/defaultSelectors/userProfile/get',
  get: () => apiGetUserProfile(),
});

export const exerciseSelectorGet = selector({
  key: 'apiData/defaultSelectors/exercise/get',
  get: () => apiGetExercise(),
});

export const nutritionSelectorGet = selector({
  key: 'apiData/defaultSelectors/nutrition/get',
  get: () => apiGetNutrition(),
});

export const dna24ProfileSelectorGet = selector({
  key: 'apiData/defaultSelectors/dna24Profile/get',
  get: () => apiGetDna24Profile(),
});

export const genotypeStatusSelectorGet = selector({
  key: 'apiData/defaultSelectors/genotypeStatus/get',
  get: () => apiGetGenotypeWithErrorCatch(),
});

export const recommenderExercisesSelectorGet = selector({
  key: 'apiData/defaultSelectors/recommenderExercises/get',
  get: ({ get }) => {
    get(recommenderExercisesRequestIdAtom);
    return apiGetRecommenderExercises();
  },
});

export const recommenderRecipesSelectorGet = selector({
  key: 'apiData/defaultSelectors/recommenderRecipes/get',
  get: ({ get }) => {
    get(recommenderRecipesRequestIdAtom);
    return apiGetRecommenderRecipes();
  },
});

export const recommenderMealplanSelectorGet = selector({
  key: 'apiData/defaultSelectors/recommenderMealplan/get',
  get: ({ get }) => {
    get(recommenderMealplanRequestIdAtom);
    return apiGetRecommenderMealplan();
  },
});
